import * as Yup from 'yup';

export const conditionalArrayRequired = <T extends string>(
  fieldName: string,
  targetValue: T,
  errorMessage: string,
  itemSchema: Yup.AnySchema = Yup.string(),
) =>
  Yup.array().when(fieldName, (value, schema) =>
    value === targetValue ? schema.of(itemSchema).min(1, errorMessage) : schema,
  );
